import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TicketItem from './TicketItem';
import Incrementer from '@/components/Incrementer';
import useEventContext from '@/contexts/event/useEventContext';
import { useTicketsSelected } from '@/store';
import min from 'lodash/min';
import { useMaxCapacityByTicket } from '@/store/tickets-zone-capacity/useMaxCapacity';

function TicketTypes({ ticket, onQuantityChange }) {
  const { t } = useTranslation();
  const { id, max_per_sale, availability } = ticket;
  const {
    event: {
      event: { max_tickets_per_booking, real_capacity },
    },
  } = useEventContext();
  const { count } = useTicketsSelected();
  const onChangeHandler = (bookingQuantity) => {
    onQuantityChange(ticket, bookingQuantity);
  };
  const { zone, zoneCount } = useMaxCapacityByTicket(id);
  return (
    <TicketItem ticket={ticket} showPrice showDesc>
      {zone ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              pr: 2,
              textAlign: 'right',
            }}
          >
            <Incrementer
              max={min([max_per_sale, availability])}
              value={0}
              disabledIncrementer={
                count >= min([max_tickets_per_booking, real_capacity]) ||
                zoneCount >= min([zone.max, zone.max - zone.availability])
              }
              onChange={onChangeHandler}
            ></Incrementer>
          </Stack>
          <Typography variant="caption2" component={'div'} sx={{ mr: 2 }}>
            {t('checkout.home.cart.zone', {
              zone: zone.id,
              zoneCount,
              max: zone.max,
            })}
          </Typography>
          <Typography variant="caption2" component={'div'} sx={{ mr: 2 }}>
            {t('checkout.home.cart.soldByZone', {
              availability: zone.availability,
            })}
          </Typography>
        </Box>
      ) : (
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{
            pr: 2,
            textAlign: 'right',
          }}
        >
          <Incrementer
            max={min([max_per_sale, availability])}
            value={0}
            disabledIncrementer={count >= max_tickets_per_booking}
            onChange={onChangeHandler}
          ></Incrementer>
        </Stack>
      )}
    </TicketItem>
  );
}

export default TicketTypes;
